<template>
  <div class="employeedashboard" id="employee">
    <div class="main-wrapper">
      <!-- <layout-loader></layout-loader> -->
      <layout-header></layout-header>
      <layout-sidebar></layout-sidebar>
      <!-- Page Wrapper -->
      <div class="page-wrapper">
        <!-- Page Content -->
        <div class="content container-fluid">
          <div class="row">
            <div class="col-md-12">
              <div class="welcome-box">
                <div class="welcome-img">
                  <img alt src="../../assets/profiles/avatar-02.jpg" />
                </div>
                <div class="welcome-det">
                  <h3>Welcome, {{agentSession.first_name}}</h3>
                  <p>{{currentDate()}}</p>
                  <!-- {{agentSession}} -->
                </div>
              </div>
            </div>
          </div>
          <div class="row">
            <div class="col-lg-8 col-md-8">
              <section class="dash-section">
                <h1 class="dash-sec-title">You are connected to the following licenses</h1>
                <div class="row">
                  <div class="col-sm-12 col-md-12">
                    <table class="table table-striped mb-0">
                      <thead>
                        <tr>
                          <th>#</th>
                          <th>License</th>
                          <th>Status</th>
                        </tr>
                      </thead>
                      <tbody>
                        <template v-if="licenseArrLoading">
                          <tr>
                            <td colspan="3">
                              <Skeleton :count="1" />
                            </td>
                          </tr>
                        </template>
                        <template v-if="licenseArr.length">
                          <tr v-for="(row,index) in licenseArr" :key="index">
                            <td>{{(index+1)}}</td>
                            <td>{{row.license_name}} ({{row.license_phone_number}})</td>
                            <td>
                              <!-- {{row.agent_id+"=="+agentSession.id}} -->
                              <div
                                v-if="row.license_id===agentSession.license_id"
                                class="badge badge-success"
                              >
                                <i class="fa fa-check-circle-o"></i> Logged In
                              </div>
                              <div class="dropdown action-label" v-else>
                                <a
                                  class="btn btn-white btn-sm btn-rounded dropdown-toggle"
                                  href="#"
                                  data-toggle="dropdown"
                                  aria-expanded="false"
                                >
                                  <i class="fa fa-dot-circle-o text-danger"></i> Inactive
                                </a>
                                <div class="dropdown-menu dropdown-menu-right">
                                  <a
                                    class="dropdown-item"
                                    :href="'/omni/connect-to-agent-owner?license_id='+row.license_id+'&agent_id='+row.agent_id"
                                  >
                                    <i class="fa fa-sign-in text-success"></i>
                                    Login
                                  </a>
                                </div>
                              </div>
                            </td>
                          </tr>
                        </template>
                        <template v-else-if="licenseArr.length<1 && !licenseArr">
                          <tr>
                            <td colspan="3" class="text-center">-empty-</td>
                          </tr>
                        </template>
                      </tbody>
                    </table>
                  </div>
                </div>
              </section>
              <section class="dash-section">
                <h1 class="dash-sec-title">Last Read Message</h1>
                <div class="row">
                  <div class="col-sm-12 col-md-12">
                    <table class="table table-striped custom-table mb-0">
                      <thead>
                        <tr>
                          <th>#</th>
                          <th>License</th>
                          <th>Agent</th>
                          <th>Participant</th>
                          <th>Last Chat</th>
                          <th class="text-center">Receive</th>
                        </tr>
                      </thead>
                      <tbody>
                        <template v-if="taskLoading">
                          <tr>
                            <td colspan="6">
                              <Skeleton :count="1" />
                            </td>
                          </tr>
                        </template>
                        <template v-if="taskRows.length">
                          <tr v-for="(row,index) in taskRows" :key="index">
                            <td>{{row.number}}</td>
                            <td>{{row.license_name}}</td>
                            <td>{{row.first_name}}</td>
                            <td class="text-wrap" style="width:100px;">{{row.message_name}}</td>
                            <td class="text-wrap">{{row.message}}</td>
                            <td class="text-right">{{formatLocalDate(row.receive_datetime)}}</td>
                          </tr>
                        </template>
                        <template v-else-if="taskRows.length<1 && !taskLoading">
                          <tr>
                            <td colspan="5" class="text-center">-empty-</td>
                          </tr>
                        </template>
                      </tbody>
                    </table>
                  </div>
                </div>
              </section>
            </div>
            <div class="col-lg-4 col-md-4">
              <div class="dash-sidebar">
                <section>
                  <h5 class="dash-title">This Month</h5>
                  <div class="card">
                    <div class="card-body">
                      <div class="time-list">
                        <div class="dash-stats-list">
                          <h4 v-if="totalRecords>0">{{rows[0].num_read}}</h4>
                          <h4 v-else>0</h4>
                          <p>Total Rooms</p>
                        </div>
                        <div class="dash-stats-list">
                          <span
                            class="text-muted"
                            v-if="totalRecords>0"
                          >{{calculateSeconds(rows[0].duration_read)}}</span>
                          <span class="text-muted" v-else>0</span>
                          <p>Avg. Time</p>
                        </div>
                      </div>
                      <div class="request-btn">
                        <div class="dash-stats-list">
                          <p>Read Message</p>
                        </div>
                      </div>
                    </div>
                  </div>
                </section>
                <section>
                  <!-- <h5 class="dash-title">Your Leave</h5> -->
                  <div class="card">
                    <div class="card-body">
                      <div class="time-list">
                        <div class="dash-stats-list">
                          <h4 v-if="totalRecords>0">{{rows[0].num_response}}</h4>
                          <h4 v-else>0</h4>
                          <p>Total Rooms</p>
                        </div>
                        <div class="dash-stats-list">
                          <span
                            class="text-muted"
                            v-if="totalRecords>0"
                          >{{calculateSeconds(rows[0].duration_response)}}</span>
                          <span class="text-muted" v-else>0</span>
                          <p>Avg. Time</p>
                        </div>
                      </div>
                      <div class="request-btn">
                        <div class="dash-stats-list">
                          <p>Response Message</p>
                        </div>
                      </div>
                    </div>
                  </div>
                </section>
                <section>
                  <!-- <h5 class="dash-title">Your time off allowance</h5> -->
                  <div class="card">
                    <div class="card-body">
                      <div class="time-list">
                        <div class="dash-stats-list">
                          <h4 v-if="totalRecords>0">{{rows[0].num_resolve}}</h4>
                          <h4 v-else>0</h4>
                          <p>Total Rooms</p>
                        </div>
                        <div class="dash-stats-list">
                          <span
                            class="text-muted"
                            v-if="totalRecords>0"
                          >{{calculateSeconds(rows[0].duration_resolve)}}</span>
                          <span class="text-muted" v-else>0</span>
                          <p>Avg. Time</p>
                        </div>
                      </div>
                      <div class="request-btn">
                        <div class="dash-stats-list">
                          <p>Resolve Message</p>
                        </div>
                      </div>
                    </div>
                  </div>
                </section>
              </div>
            </div>
          </div>
        </div>
        <!-- /Page Content -->
      </div>
      <!-- /Page Wrapper -->
    </div>
  </div>
</template>
<script>
import { mapGetters } from "vuex";
import {
  formatLocalDate,
  nFormatter,
  getCurrentMonth,
  currentDate,
  calculateSeconds
} from "@/utils/helper";
import { Skeleton } from "vue-loading-skeleton";

import LayoutHeader from "@/components/layouts/Header.vue";
import LayoutSidebar from "@/components/layouts/Sidebar.vue";
export default {
  components: {
    LayoutHeader,
    LayoutSidebar,
    Skeleton
  },
  data() {
    return {
      licenseArr: [],
      licenseArrLoading: false,
      taskLoading: false,
      taskTotalRecords: 0,
      taskRows: [],
      taskParams: {
        columnFilters: {
          license_id: "",
          agent_id: "",
          is_resolved: "0"
        },
        page: 1,
        perPage: 20 // perPage
      },
      loading: false,
      currentPage: 1,
      rows: [
        {
          number: 1,
          agent_id: "",
          network_id: "",
          num_read: "0",
          agent_id: "",
          duration_read: "0",
          duration_resolve: "0",
          duration_response: "0",
          first_name: "",
          last_name: "",
          network_id: "",
          num_read: "0",
          num_resolve: "0",
          num_response: "0",
          number: 0
        }
      ],
      totalRecords: 0,
      serverParams: {
        columnFilters: {
          period: this.getCurrentMonth(),
          agent_id: ""
        },
        page: 1,
        perPage: 20 // perPage
      }
    };
  },
  created() {
    this.summaryAgents();
    this.monthlyAgentsStatistic();
    this.licenseByAgent();
    // this.currentPage = this.serverParams.page;
  },
  computed: {
    ...mapGetters([
      "agentSession"
      // "NEW_NUM_UNREAD_MESSAGE_ROOM_Data"
    ]),
    RefreshRoomData() {
      return this.$store.state.pusher.RefreshRoomData;
    },
    RemoveRoomData() {
      return this.$store.state.pusher.RemoveRoomData;
    },
    currentpage() {
      return this.$route.path;
    }
  },
  methods: {
    licenseByAgent() {
      let agentId = "";
      if (typeof this.agentSession.id!='undefined' && this.agentSession.id != "") {
        agentId = this.agentSession.id;
      }
      this.licenseArrLoading = true;
      this.$store
        .dispatch("omniroom/licenseByAgent", agentId) // sesuai kan dengan method di API
        .then(response => {
          const { data } = response;

          this.licenseArr = data;
          this.licenseArrLoading = false;
        });
    },
    formatLocalDate(value) {
      return formatLocalDate(value);
    },
    nFormatter(value) {
      return nFormatter(value);
    },
    async summaryAgents() {
      this.taskParams.columnFilters.agent_id = this.agentSession.id;
      this.taskLoading = await true;
      this.taskParams.page =
        this.taskParams.page - 1 <= 0
          ? await 0
          : await ((this.taskParams.page - 1) * this.taskParams.perPage);

      await this.$store
        .dispatch("member/summaryAgents", this.taskParams) // sesuai kan dengan method di API
        .then(response => {
          const { data } = response;
          this.taskTotalRecords = data.totalRecords;
          this.rowPage = data.page;
          this.taskRows = data.data;
          // console.log("rows", this.rows);
          this.taskLoading = false;
        })
        .catch(error => {
          this.taskLoading = false;
          console.log(error);
        });
    },
    calculateSeconds(value) {
      return calculateSeconds(value);
    },
    getCurrentMonth() {
      return getCurrentMonth();
    },
    monthlyAgentsStatistic() {
      this.loading = true;
      this.serverParams.page =
        this.serverParams.page - 1 <= 0
          ? 0
          : (this.serverParams.page - 1) * this.serverParams.perPage;

      this.serverParams.columnFilters.agent_id = this.agentSession.id;
      this.$store
        .dispatch("member/monthlyAgentsStatistic", this.serverParams) // sesuai kan dengan method di API
        .then(response => {
          const { data } = response;
          this.totalRecords = data.totalRecords;
          this.rowPage = data.page;
          this.rows = data.data;
          // console.log("rows", this.rows);
          this.loading = false;
        })
        .catch(error => {
          console.log(error);
          this.loading = false;
        });
    },
    currentDate() {
      return currentDate();
    }
  },
  mounted() {
    if ($(".floating").length > 0) {
      $(".floating")
        .on("focus blur", function(e) {
          $(this)
            .parents(".form-focus")
            .toggleClass(
              "focused",
              e.type === "focus" || this.value.length > 0
            );
        })
        .trigger("blur");
    }
  },
  name: "employeedashboard"
};
</script>


// WEBPACK FOOTER //
// src/views/dashboard/employeedashboard.vue